import React, { useState } from 'react';
import { Editor, IAllProps } from '@tinymce/tinymce-react';
import StrapiMedia from '../StrapiMedia';
import { Button, Dialog } from '@material-ui/core';

interface TinyMCEProps extends IAllProps {
	height: number,
}

const TinyMCE = (props: Partial<TinyMCEProps>) => {
	const [open, setOpen] = useState<boolean>(false);
	const [curentMedia,setCurentMedia] = useState<any[]>([]);
	const [curentCallback, setCurentCallback] = useState<any>(null);

	return (
	<>
		<Dialog open={open} onClose={() => {
			setOpen(false);
			curentCallback(curentMedia[0].url, {});
		}}>
			<StrapiMedia value={curentMedia} onChange={setCurentMedia}/>
			<Button onClick={() => {
				setOpen(false);
				curentCallback(curentMedia[0].url, {});			
			}}>Ok</Button>
		</Dialog>
		<Editor
			apiKey="96ywc3xl8wyoje0n497ko7k2px7dvibr6ecx2yjrizte4koi"
			init={{
				file_picker_callback: (currentCallback: any, v: any, m: any) => {
					setOpen(true);
					setCurentCallback(() => currentCallback);
				},
				height: props.height || 500,
				width: "100%",
				menubar: true,
				plugins: [
					'advlist autolink lists link image charmap print preview anchor table autosave',
					'searchreplace visualblocks code fullscreen',
					'insertdatetime media table code help wordcount', // 'powerpaste'
				],
				toolbar:
					'image | undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | media | code restoredraft | help',
				default_link_target: '_blank',
				// powerpaste_allow_local_images: true,
				// powerpaste_word_import: 'prompt', // optional
				// powerpaste_html_import: 'prompt', // optional
				content_style: `.lettrine::first-letter {
					float:              left;
					font-size:          5rem;
					font-weight:        800;
					line-height:        5rem;
					margin-right:       .4rem;
				}`,
				formats: {
					lettrine: { selector: "p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img", classes: "lettrine" },
				},
				style_formats: [
					{ title: "Lettrine", format: "lettrine" },
				],
			}}
			{...props}
		/>
	</>)
}

export default TinyMCE;